import React from "react"
import TechnologistImage from "../images/technologist-light-skin.png"

const mainImage = {
  image: <TechnologistImage />,
  alt: "emoji",
}

export default mainImage
